export default __webpack_public_path__ + "/dist/images/6574781.69a1feb28814dd164412db247a2e6ec6.png";